
import { Component, Vue } from 'vue-property-decorator'
import axios from 'axios'
import { MstPointHistoryVO } from './vo/mypage.vo';

@Component
export default class Point extends Vue {
    inited = false;
    showNotice = false;
    pointDiv = 1;

    memPointAmt = 0;
    pointTobeExtinguished = 0;
    pointHistory = [] as Array<MstPointHistoryVO>;

    get pointHistory1(): Array<MstPointHistoryVO>{
        return this.pointHistory.filter(point=>{
          return point.point > 0;
        });
    }

    get pointHistory2(): Array<MstPointHistoryVO>{
        return this.pointHistory.filter(point=>{
          return point.point < 0;
        });
    }    

    created(): void {
        axios.get('/mypage/point/history')
        .then(r=>{
            this.memPointAmt = r.data.memPointAmt;
            this.pointTobeExtinguished = r.data.pointTobeExtinguished;
            this.pointHistory = r.data.pointHistory;
            this.inited = true;
        })
    }
}
